module.exports = __webpack_public_path__ + "img/Hamburger_Icon.0a975a90.svg";